import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import type { TProductTypeTabConfig } from '../../types';

export const ProductTypeCardTitle = (props: TProductTypeTabConfig) => {
  const { title, subtitle: mobileSubtitle, subtitleDesktop } = props;
  const isMobile = useIsMobile();

  const subtitle = isMobile ? mobileSubtitle : subtitleDesktop;

  return (
    <Space
      direction="vertical"
      size={2}
    >
      <Text
        strong
        size={isMobile ? 16 : 14}
      >
        {title}
      </Text>
      <Text
        size={12}
        className="h-color-D60"
      >
        {subtitle}
      </Text>
    </Space>
  );
};
